/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc 点击更多时,分页查询新闻聚焦信息
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export class SearchTheaterNewsPageParams {
  constructor(
    public typeId: string,
    public page?: number,
    public pageSize?: number
  ) {}
}

export default async function (
  params: SearchTheaterNewsPageParams,
  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: cms.IPage<cms.TheaterNewsDto>;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "get",
    url: `/cms/theater/news-notice/page`,

    params,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
